import React, { forwardRef } from 'react';
import { Globe, Mail, Phone } from 'lucide-react';

export const UserInvoice = forwardRef(({ villaName, villaAddress, invoiceNo, dateIssued, bookings}, ref) => {
  const totalAmount = bookings.reduce((sum, booking) => sum + (booking.amount || 0), 0);
  
  const formatDate = (timestamp, timing) => {
    if (!timestamp || isNaN(timestamp)) return "N/A";
    const date = new Date(timestamp);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    return timing ? `${formattedDate} (${timing})` : formattedDate;
  };

  const companyWebsite = "www.villakosh.in";
  const companyEmail = "contact@villakosh.in";
  

  return (
    <div ref={ref} className="w-full bg-white p-4 md:p-8 rounded-lg min-w-[800px]">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-bold tracking-wider mb-6">VILLAKOSH</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          <div>
            <h2 className="text-lg md:text-xl font-semibold mb-2">VILLA DETAILS</h2>
            <p className="text-base md:text-lg font-medium mb-1">{villaName}</p>
            <p className="text-sm text-gray-600">{villaAddress}</p>
          </div>
          
          <div className="md:text-right">
            <h2 className="text-lg md:text-xl font-semibold mb-2">BOOKING INVOICE</h2>
            <div className="space-y-1">
              <p className="text-sm">Date: {dateIssued}</p>
              <p className="text-sm">Invoice No: {invoiceNo}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Billing Details */}
      <div className="mb-8 overflow-visible"> {/* Changed from overflow-x-auto */}
        <h3 className="text-lg font-semibold border-b-2 border-gray-800 pb-2 mb-4">
          BOOKING DETAILS
        </h3>
        
        <div className="w-full">
          <table className="w-full table-fixed"> {/* Added table-fixed */}
            <thead>
              <tr className="text-left border-b-2 border-gray-300">
                <th className="py-2 px-2 md:px-4 text-sm">BOOKING ID</th>
                <th className="py-2 px-2 md:px-4 text-sm">GUEST</th>
                <th className="py-2 px-2 md:px-4 text-sm">CHECK-IN</th>
                <th className="py-2 px-2 md:px-4 text-sm">CHECK-OUT</th>
                <th className="py-2 px-2 md:px-4 text-sm text-right">AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking) => (
                <tr key={booking.bookingId} className="border-b border-gray-200">
                  <td className="py-2 px-2 md:px-4 text-sm">#{booking.bookingId}</td>
                  <td className="py-2 px-2 md:px-4 text-sm">{booking.guestName}</td>
                  <td className="py-2 px-2 md:px-4 text-sm">{formatDate(booking.checkIn, booking.checkInTiming)}</td>
                  <td className="py-2 px-2 md:px-4 text-sm">{formatDate(booking.checkOut, booking.checkOutTiming)}</td>
                  <td className="py-2 px-2 md:px-4 text-sm text-right">₹{Number(booking.amount).toLocaleString('en-IN')}</td>
                </tr>
              ))}
              <tr className="font-semibold border-t-2 border-gray-300">
                <td colSpan={4} className="py-3 px-2 md:px-4 text-right">Total Amount</td>
                <td className="py-3 px-2 md:px-4 text-right">₹{totalAmount.toLocaleString('en-IN')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 pt-4 border-t-2 border-gray-800">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
          <p className="font-semibold mb-2 md:mb-0">THANK YOU FOR BOOKING WITH US</p>
          <p className="font-semibold">VILLAKOSH</p>
        </div>
        <div className="flex flex-col md:flex-row justify-between text-sm text-gray-600 gap-2 md:gap-4">
          <div className="flex items-center">
            <Globe className="h-4 w-4 mr-2" />
            <a href={`http://${companyWebsite}`} target="_blank" rel="noopener noreferrer">{companyWebsite}</a>
          </div>
          <div className="flex items-center">
            <Mail className="h-4 w-4 mr-2" />
            <a href={`mailto:${companyEmail}`} target="_blank" rel="noopener noreferrer">{companyEmail}</a>
          </div>
        </div>
      </div>
    </div>
  );
});